<template>
<div class="new-body new-form">
    <div class="new-content new-inr">
        <header class="form-header">
            <span>
                <h1>{{ branch.name }} 입실계약서</h1>
            </span>
        </header>
        <main id="new-container" class="new-form-container">
            <figure class="form-logo">
                <img src="@/assets/new_images/huesik_logo_brown.png" alt="HUESIKLOGO" class="logo" style="max-height: 100px;">
            </figure>
            <form>
                <div class="d-flex">
                    <div class="input-wrap">
                        <label>
                            <span class="ast">*</span>
                            <strong class="label-text">지점</strong>
                        </label>
                        <input type="text" placeholder="지점명을 입력해주세요." v-model="branch.name" readonly />
                    </div>
                    <div class="input-wrap" id="room_pk">
                        <label>
                            <span class="ast">*</span>
                            <strong class="label-text">방 호수</strong>
                        </label>
                        <select style="width:100%; height:45px; border-bottom:1px solid #eee; outline:none; padding:12px 0;" v-model="guest.room_pk">
                            <option value="" disabled selected>입실 예정인 방 호수를 선택해주세요.</option>
                            <option v-for="(option, idx) in branch.huesik_room" :key="`room_${idx}`" :value="option.pk">
                                {{ option.room_number }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="d-flex">
                    <div class="input-wrap" id="name">
                        <label>
                            <span class="ast">*</span>
                            <strong class="label-text">이름</strong>
                        </label>
                        <input type="text" placeholder="이름을 입력해주세요." v-model="guest.name" />
                    </div>
                    <div class="input-wrap" id="gender">
                        <label>
                            <span class="ast">*</span>
                            <strong class="label-text">성별</strong>
                        </label>
                        <select style="width:100%; height:45px; border-bottom:1px solid #eee; outline:none; padding:12px 0;" v-model="guest.gender">
                            <option v-for="(option, idx) in gender_options" :key="`gender_${idx}`" :value="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="d-flex">
                    <div class="input-wrap" id="age">
                        <label>
                            <span class="ast">*</span>
                            <strong class="label-text">생년월일</strong>
                        </label>
                        <input type="text" id="birth_date" placeholder="YYYY-MM-DD" readonly v-model="guest.birth_date" />
                        <button class="delete" onclick="return false;" style="background:white;" @click="viewCalendar()">
                            <img src="@/assets/new_images/icon-calendar.png">
                        </button>
                    </div>
                    <div class="input-wrap" id="address">
                        <label>
                            <span class="ast">*</span>
                            <strong class="label-text">이전 주소지</strong>
                        </label>
                        <div class="d-flex">
                            <select style="width:100%; height:45px; border-bottom:1px solid #eee; outline:none; padding:12px 0;" v-model="address_1" @change="selectSigugun(false)">
                                <option v-for="(option, idx) in sigugun" :key="`gender_${idx}`" :value="option.key">
                                    {{ option.key }}
                                </option>
                            </select>
                            <select style="width:100%; height:45px; border-bottom:1px solid #eee; outline:none; padding:12px 0;" v-model="address_2" v-show="address_2">
                                <option v-for="(option, idx) in sigugun_arr" :key="`gender_${idx}`" :value="option">
                                    {{ option }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="d-flex">
                    <div class="input-wrap" id="phone_no">
                        <label>
                            <span class="ast">*</span>
                            <strong class="label-text">휴대폰 번호</strong>
                        </label>
                        <input type="text" placeholder="휴대폰 번호 (- 제외)" v-model="guest.phone_no" maxlength="11" />
                        <button onclick="return false;" @click="smsCheck()">인증번호 발송</button>
                    </div>
                    <div class="input-wrap" id="verify_number">
                        <label>
                            <span class="ast">*</span>
                            <strong class="label-text">인증번호</strong>
                        </label>
                        <input type="text" placeholder="인증번호" v-model="verifyNumber" maxlength="4" />
                        <button onclick="return false;" @click="smsConfirm()">인증번호 확인</button>
                    </div>
                </div>
                <div class="d-flex">
                    <div class="input-wrap" id="sub">
                        <label>
                            <span class="ast">*</span>
                            <strong class="label-text">비상 연락처</strong>
                        </label>
                        <div class="d-flex">
                            <input type="text" placeholder="비상 연락처" maxlength="11" style="margin-right:10px" v-model="e_phone_no" />
                            <input type="text" placeholder="관계(부,모,지인 등)" v-model="relationship" />
                        </div>
                    </div>
                    <div class="input-wrap" id="price">
                        <label>
                            <span class="ast">*</span>
                            <strong class="label-text">입실료 (만원)</strong>
                            <span class="inform">
                                <a class="tooltip-wrap">
                                    <img src="@/assets/new_images/icon-inform.png" alt="inform icon">
                                    <span class="tooltip-content">
                                        휴식 레지던스 매니저에게 안내받은 입실료를 만원 단위로 입력해주세요.
                                    </span>
                                </a>
                            </span>
                        </label>
                        <input type="number" placeholder="안내받은 입실료를 입력해주세요." min="0" v-model="normal_price" />
                    </div>
                </div>
                <div class="input-wrap" id="job_etc">
                    <label>
                        <span class="ast">*</span>
                        <strong class="label-text">직업</strong>
                    </label>
                    <div class="d-flex check-5" style="flex-wrap:wrap; padding:10px 0 0 0">
                        <span class="checkbox-button" style="width:calc(100%/5 - 10px); flex: none" v-for="(option, idx) in job_options" :key="`job_${idx}`" :class="{checked:option.checked}" @click="changeType(option.text, 'job')">
                            <input type="checkbox" />
                            <label>
                                <span class="checkmark"></span>
                                {{ option.text }}
                            </label>
                        </span>
                        <input type="text" placeholder="직업을 입력해주세요." v-model="job_etc" v-show="job_isShow" />
                    </div>
                </div>
                <div class="input-wrap" id="fromWhere_etc">
                    <label>
                        <span class="ast">*</span>
                        <strong class="label-text">최초 인지 경로</strong>
                    </label>
                    <div class="d-flex check-5" style="flex-wrap:wrap; padding:10px 0 0 0">
                        <span class="checkbox-button" style="width:calc(100%/5 - 10px); flex: none" v-for="(option, idx) in fromWhere_options" :key="`fromWhere_${idx}`" :class="{checked:option.checked}" @click="changeType(option.text, 'fromWhere')">
                            <input type="checkbox" />
                            <label>
                                <span class="checkmark"></span>
                                {{ option.text }}
                            </label>
                        </span>
                        <input type="text" placeholder="최초 인지 경로를 입력해주세요." v-model="fromWhere_etc" v-show="fromWhere_isShow" />
                    </div>
                </div>
                <div class="input-wrap" id="intro" style="margin-bottom: 20px;">
                    <label>
                        <span class="ast">*</span>
                        <strong class="label-text">휴직 레지던스 안내 및 유의사항</strong>
                    </label>
                </div>
                <div class="information-box" style="margin-top:20px; margin-bottom: 50px;">
                    <ul class="information-lists">
                        <li class="information-list">
                            □ <p>매월 10일은 소방점검일 입니다.</p>
                        </li>
                        <li class="information-list">
                            □<p>실내흡연 적발시 환불없이 강제 퇴실 조치합니다.</p>
                        </li>
                        <li class="information-list">
                            □<p>외출시 에어컨, 전기 및 온수매트, 컴퓨터, 온냉풍기 등 전원을 끄지 않으면 전기세 50,000원이 추가 부가됩니다.</p>
                        </li>
                        <li class="information-list">
                            □<p>현금영수증은 필요 시 매달 요청주셔야 합니다.</p>
                        </li>
                        <li class="information-list">
                            □<p>퇴실 시 벽지손상, 쓰레기방치, 기물파손에 대한 배상은 보증금에서 제(除)합니다.</p>
                        </li>
                    </ul>
                </div>

                <div class="input-wrap" id="intro" style="margin-bottom: 0px;">
                    <label>
                        <span class="ast">*</span>
                        <strong class="label-text">휴직 레지던스 규정</strong>
                    </label>
                </div>
                <div class="information-box" style="margin-top:20px; margin-bottom: 30px;">
                    <h4>1. 기본 규칙</h4>
                    <ul class="information-lists">
                        <li class="information-list">
                            ①<p>본 원은 <strong><u>1인 1실</u></strong>을 <strong>원칙</strong>으로 한다. (2인실은 상담 요망)</p>
                        </li>
                        <li class="information-list">
                            ②<p>기본 <strong><u>계약기간</u></strong>은 <strong><u>1개월</u></strong>이며, 입실료는 <strong>매월 <u>선납</u></strong>을 원칙으로 한다.</p>
                        </li>
                        <li class="information-list">
                            ③<p>퇴실 시, 최소 10일 전에 미리 통보하는 것을 원칙으로 한다.</p>
                        </li>
                        <li class="information-list">
                            ④<p>계약 만료 전, 조기 퇴실 시 위약금 5만원을 부담한다.</p>
                        </li>
                    </ul>
                    <br />
                    <h4>2. 입실료 관련 규정</h4>
                    <ul class="information-lists">
                        <li class="information-list">
                            <p>입실 이전에 계약을 해지할 경우, 총 입실료의 10%를 공제한 금액을 환급한다. 입실 이후에 계약을 해지할 경우, 총 입실료에서 계약해지일까지 일할 계산한 이용료를 공제한 나머지 금액을 환급한다.</p>
                        </li>
                    </ul>
                    <br />
                    <h4>3. 입실료 납부 및 권리양도 불가</h4>
                    <ul class="information-lists">
                        <li class="information-list">
                            ①<p>본원의 입실권리를 타인에게 대여 및 양도할 수 없다.</p>
                        </li>
                        <li class="information-list">
                            ②<p>기간 갱신의 의사표시 없이 만료일을 무단 경과한 경우 각 실의 물건을 본원 임의로 정리 처분할 수 있으며, 관리자가 1개월간 별도 보관 후 기간이 경과하면 관리자가 임의로 처분할 수 있다.</p>
                        </li>
                    </ul>
                    <br />
                    <h4>4. 직권 퇴실</h4>
                    <ul class="information-lists">
                        <li class="information-list">
                            <p><strong>다음 각 호에 해당하는 경우 관리인(원장, 실장, 총무)의 직권으로 퇴실(退室)조치를 취할 수 있다.</strong></p>
                        </li>
                        <li class="information-list">
                            ①<p>옆 실의 원내 생활에 불편을 끼치는 <strong><u>소란, 소음 유발, 실내 흡연, 음주, 폭력, 절도</u></strong> 행위 등</p>
                        </li>
                        <li class="information-list">
                            ②<p>허가 없이 외부인 동반 입실, <strong><u>풍기문란</u></strong>, 지정 장소 외의 취사 행위 등</p>
                        </li>
                        <li class="information-list">
                            ③<p>정신질환 및 전염병 질환자로 타인에 해(害)를 끼치는 경우</p>
                        </li>
                        <li class="information-list">
                            ④<p>타인에게 위해를 줄 수 있는 화기, 화약 약품 및 혐오 물건 또는 애완동물 등을 원내 반입하는 행위 등 기타 공동생활을 위한 관리인의 타당한 권고를 임의(任意)로 거부한 경우</p>
                        </li>
                    </ul>
                    <br />
                    <h4>5. 손해배상 및 배상책임</h4>
                    <ul class="information-lists">
                        <li class="information-list">
                            <p>제공한 숙박시설 및 안전시설 등의 미비 사용으로 사고가 발생시에는 이의 없이 치료비는 물론 그에 수반되는 모든 손해배상(물질적, 정신적)과 민사, 형사 상의 책임을 진다.</p>
                        </li>
                    </ul>
                </div>

                <!-- 서명 -->
                <div id="canvas_container">
                    <canvas id="canvas" style="width: 100%;"></canvas>
                </div>
                <div class="input-wrap" id="intro" style="margin-bottom: 35px;">
                    <label>
                        <strong class="label-text">상단에 서명 후, 내용 확인을 체크해주세요.</strong>
                        <button class="delete" onclick="return false;" @click="canvasResize()" style="bottom:auto;">
                            <img src="@/assets/new_images/icon-trash.png">
                        </button>
                    </label>
                </div>
                <div class="input-wrap" id="intro" style="margin-bottom: 35px; margin-left: 10px;">
                    <label>
                        <strong class="label-text">작성일 : {{ today }}</strong>&nbsp;&nbsp;
                        <strong class="label-text">입실자 : {{ guest.name }}</strong>
                    </label>
                </div>
                <div class="input-wrap" id="intro" style="margin-bottom: 20px; margin-left: 10px;">
                    <label>
                        <input type="checkbox" style="width:18px; height: 18px; margin-right: 5px;" v-model="isContentCheck" />
                        <strong class="label-text">상기 내용을 모두 확인하고 이에 동의합니다</strong>
                    </label>
                </div>
                <div class="input-wrap" id="intro" style="margin-bottom: 70px; margin-left: 10px;">
                    <label>
                        <input type="checkbox" style="width:18px; height: 18px; margin-right: 5px;" v-model="isPrivacyCheck" />
                        <span class="inform">
                            <a class="tooltip-wrap">
                                <img src="@/assets/new_images/icon-inform.png" alt="inform icon">
                                <span class="tooltip-content">
                                    <strong>[필수 개인정보 수집 및 이용 동의 약관]</strong><br />
                                    <strong>항목</strong> : 이름, 성별, 생년월일, 직업, 휴대폰 번호, 비상 연락처<br />
                                    <strong>목적</strong> : 휴직 레지던스 입실 계약서 및 입실자 식별, 회원 관리<br />
                                    <strong>보유 및 이용 기간</strong> : 퇴실 시, 180일간 보관 후 파기
                                </span>
                            </a>
                        </span>
                        <strong class="label-text">개인정보 수집 및 이용 동의</strong>
                    </label>
                </div>
                <!-- 캡쳐 시, fixed 되어있는 버튼이 같이 적용 -->
                <div class="submit-button-wrap" v-if="!isLoading">
                    <button class="submit_contract" onclick="return false;" @click="saveContract()">제출하기</button>
                </div>
                <div class="submit-button-wrap" v-else>
                    <button class="submit_contract" onclick="return false;">등록 중...</button>
                </div>
            </form>
        </main>
        <div class="loading-wrap">
            <svg class="tea" width="37" height="48" viewbox="0 0 37 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M27.0819 17H3.02508C1.91076 17 1.01376 17.9059 1.0485 19.0197C1.15761 22.5177 1.49703 29.7374 2.5 34C4.07125 40.6778 7.18553 44.8868 8.44856 46.3845C8.79051 46.79 9.29799 47 9.82843 47H20.0218C20.639 47 21.2193 46.7159 21.5659 46.2052C22.6765 44.5687 25.2312 40.4282 27.5 34C28.9757 29.8188 29.084 22.4043 29.0441 18.9156C29.0319 17.8436 28.1539 17 27.0819 17Z" stroke="var(--secondary)" stroke-width="2"></path>
                <path d="M29 23.5C29 23.5 34.5 20.5 35.5 25.4999C36.0986 28.4926 34.2033 31.5383 32 32.8713C29.4555 34.4108 28 34 28 34" stroke="var(--secondary)" stroke-width="2"></path>
                <path id="teabag" fill="var(--secondary)" fill-rule="evenodd" clip-rule="evenodd" d="M16 25V17H14V25H12C10.3431 25 9 26.3431 9 28V34C9 35.6569 10.3431 37 12 37H18C19.6569 37 21 35.6569 21 34V28C21 26.3431 19.6569 25 18 25H16ZM11 28C11 27.4477 11.4477 27 12 27H18C18.5523 27 19 27.4477 19 28V34C19 34.5523 18.5523 35 18 35H12C11.4477 35 11 34.5523 11 34V28Z">
                </path>
                <path id="steamL" d="M17 1C17 1 17 4.5 14 6.5C11 8.5 11 12 11 12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke="var(--secondary)"></path>
                <path id="steamR" d="M21 6C21 6 21 8.22727 19 9.5C17 10.7727 17 13 17 13" stroke="var(--secondary)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
        </div>
    </div>
</div>
</template>

<script>
import sigugun from "../const/sigugun";

export default {
    data() {
        return {
            isLoading: false,
            PHONE_REG_EXP: /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/,
            id: this.$route.query.id,

            today: moment().format("YYYY-MM-DD"),
            minYear: 1950,
            maxYear: parseInt(moment().format('YYYY'), 10) - 15,

            branch: {
                name: "",
                huesik_room: []
            },

            guest: {
                branch_pk: this.$route.query.id,
                room_pk: "",
                name: "",
                phone_no: "",
                gender: "M",
                birth_date: "",
                age: "",
                address: "",
                job: "",
                from_where: "",
                contract: {
                    flag: "Y",
                    url: null,
                },
                deposit: {
                    flag: "N",
                    price: "50000",
                },
                memo: "",
                is_deleted: 0,
                is_expired: 0,
                is_public: 0
            },

            gender_options: [{
                    value: "M",
                    text: "남자"
                },
                {
                    value: "W",
                    text: "여자"
                }
            ],

            sigugun: sigugun,
            sigugun_arr: [],
            address_1: "",
            address_2: "",

            normal_price: "",
            e_phone_no: "",
            relationship: "",
            job_etc: "",
            job_isShow: false,

            fromWhere_etc: "",
            fromWhere_isShow: true,

            fromWhere_options: [{
                    text: "기타",
                    checked: true
                },
                {
                    text: "지인",
                    checked: false
                },
                {
                    text: "블로그",
                    checked: false
                },
                {
                    text: "고시락",
                    checked: false
                },
                {
                    text: "고방",
                    checked: false
                },
                {
                    text: "룸앤스페이스",
                    checked: false
                },
                {
                    text: "네이버",
                    checked: false
                },
                {
                    text: "구글",
                    checked: false
                },
                {
                    text: "인스타그램",
                    checked: false
                },
                {
                    text: "페이스북",
                    checked: false
                }
            ],

            job_options: [{
                    text: "학생",
                    checked: true
                },
                {
                    text: "무직/취업준비",
                    checked: false
                },
                {
                    text: "직장인",
                    checked: false
                },
                {
                    text: "공무원",
                    checked: false
                },
                {
                    text: "전문직",
                    checked: false
                },
                {
                    text: "자유직/프리랜서",
                    checked: false
                },
                {
                    text: "자영업/경영직",
                    checked: false
                },
                {
                    text: "기타",
                    checked: false
                }
            ],

            verifyNumber: "",

            is_smsCheck: {
                verifyNumber: "w.,mk#�b�T~;h",
                flag: false
            },

            canvas: null,
            div: null,
            ctx: null,
            drawble: false,

            isContentCheck: false,
            isPrivacyCheck: false
        }
    },
    async mounted() {
        const result = await this.axios.get(`/contract/branch/${this.id}`);

        // * 데이터가 없을 경우, 메인 페이지로 이동
        if (!result.data) {
            alert("올바르지 않은 경로입니다.\nURL을 확인하여 다시 시도해주세요.");
            this.goToBack();
        }

        // 숲속 휴식인 경우 -> room 데이터만 가져온다
        if (Array.isArray(result.data)) {
            this.branch.name = `[광운대역 숲속 휴식]`;
            result.data.map(item => item.room_number = `[${item.room_type === "kosiwon" ? "고시원" : "쉐어하우스"}] ${item.room_number}`);
            this.branch.huesik_room = result.data;
        } else { // 그 외에 일반 고시원인 경우 -> 지점과 room 데이터를 같이 가져온다
            this.branch = result.data;
            this.branch.name = `[휴식 ${this.branch.name}]`;
        }

        // * tooltips init
        const tooltips = [].slice.call(document.querySelectorAll(".tooltip-wrap"));

        tooltips.forEach((tooltip) => {
            const tooltipSpan = tooltip.querySelector(".tooltip-content");

            tooltip.onmousemove = (e) => {
                tooltipSpan.style.top = `${e.clientY + 10}px`;
                tooltipSpan.style.left = `${e.clientX + 10}px`;
            };
        });

        // * calendar init
        $("#birth_date").daterangepicker({
            autoUpdateInput: false,
            opens: "center",
            singleDatePicker: true,
            showDropdowns: true,
            minYear: this.minYear,
            maxYear: this.maxYear + 1,
            startDate: `${this.maxYear}-01-01`,
            locale: {
                format: "YYYY-MM-DD",
                cancelLabel: "취소",
                applyLabel: "확인",
                daysOfWeek: ["일", "월", "화", "수", "목", "금", "토"],
                monthNames: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"]
            }
        });

        $("#birth_date").on("apply.daterangepicker", (_, picker) => {
            this.guest.birth_date = picker.startDate.format("YYYY-MM-DD");
            this.guest.age = (moment().diff(moment(picker.startDate).format("YYYY"), 'years') + 1).toString();
        });
        $("#birth_date").on("cancel.daterangepicker", () => {
            this.guest.birth_date = "";
            this.guest.age = "";
        });

        this.selectSigugun(true);

        this.$nextTick(() => {
            // canvas signature init
            this.canvas = $("#canvas");
            this.div = $("#canvas_container");
            this.ctx = this.canvas[0].getContext("2d");

            // * resize 시, 서명이 지워지기 때문에 삭제 처리
            // $(window).on("resize", this.canvasResize);

            // PC 이벤트 등록
            this.canvas.on("mousedown", this.pcDraw);
            this.canvas.on("mousemove", this.pcDraw);
            this.canvas.on("mouseup", this.pcDraw);
            this.canvas.on("mouseout", this.pcDraw);

            // 모바일 이벤트 등록
            this.canvas.on("touchstart", this.mobileDraw);
            this.canvas.on("touchend", this.mobileDraw);
            this.canvas.on("touchcancel", this.mobileDraw);
            this.canvas.on("touchmove", this.mobileDraw);

            this.canvasResize(); // 최초 캔버스 사이즈 Check
        });

    },
    methods: {
        canvasResize() {
            this.canvas[0].width = this.div.width();
            this.canvas[0].height = this.div.height();
        },
        pcDraw(evt) {
            switch (evt.type) {
                case "mousedown": {
                    this.drawble = true;
                    this.ctx.beginPath();
                    this.ctx.moveTo(this.getPcPosition(evt).X, this.getPcPosition(evt).Y);
                }
                break;

            case "mousemove": {
                if (this.drawble) {
                    this.ctx.lineTo(this.getPcPosition(evt).X, this.getPcPosition(evt).Y);
                    this.ctx.stroke();
                }
            }
            break;

            case "mouseup":
            case "mouseout": {
                this.drawble = false;
                this.ctx.closePath();
            }
            break;
            }
        },
        mobileDraw(evt) {
            switch (evt.type) {
                case "touchstart": {
                    this.drawble = true;
                    this.ctx.beginPath();
                    this.ctx.moveTo(this.getMobilePosition(evt).X, this.getMobilePosition(evt).Y);
                }
                break;

            case "touchmove": {
                if (this.drawble) {
                    // 스크롤 및 이동 이벤트 중지
                    evt.preventDefault();
                    this.ctx.lineTo(this.getMobilePosition(evt).X, this.getMobilePosition(evt).Y);
                    this.ctx.stroke();
                }
            }
            break;

            case "touchend":
            case "touchcancel": {
                this.drawble = false;
                this.ctx.closePath();
            }
            break;
            }
        },
        getPcPosition(evt) {
            var x = evt.pageX - this.canvas.offset().left;
            var y = evt.pageY - this.canvas.offset().top;
            return {
                X: x,
                Y: y
            };
        },
        getMobilePosition(evt) {
            var x = evt.originalEvent.changedTouches[0].pageX - this.canvas.offset().left;
            var y = evt.originalEvent.changedTouches[0].pageY - this.canvas.offset().top;
            return {
                X: x,
                Y: y
            };
        },
        viewCalendar() {
            $("#birth_date").focus();
        },
        selectSigugun(flag) {
            if (flag) {
                this.address_1 = this.sigugun[0].key;
            }
            this.sigugun_arr = this.sigugun.find(item => item.key === this.address_1).arr;
            this.address_2 = this.sigugun_arr[0];
        },
        goToBack() {
            this.$router.push('/');
        },
        async smsCheck() {
            if (this.guest.phone_no.trim() === "") {
                this.guest.phone_no = "";
                alert("휴대폰 번호를 입력해주세요.");
                return;
            }

            if (!this.PHONE_REG_EXP.test(this.guest.phone_no)) {
                alert("올바른 휴대폰 번호를 입력해주세요.");
                return;
            }

            this.axios.get(`/huesik_tower/sendSms/${this.guest.phone_no}/guestContract`).then(res => {
                this.is_smsCheck.flag = false; // 인증 여부 초기화
                this.is_smsCheck.verifyNumber = res.data.result; // 백단에서 전달 받은 인증번호 저장
                alert("인증번호가 4자리가 발송되었습니다.");
            }).catch(error => {
                console.log(error);
                alert("휴대폰 인증 중에 오류가 발생하였습니다.\n다시 시도해주세요.");
            });
        },
        smsConfirm() {
            if (this.verifyNumber === this.is_smsCheck.verifyNumber) {
                this.is_smsCheck.flag = true;
                $("#phone_no").removeClass("error");
                $("#verify_number").removeClass("error");
                alert("휴대폰 인증이 완료되었습니다.");
            } else {
                alert("인증번호가 일치하지 않습니다.\n다시 시도해주세요.")
            }
        },
        changeType(text, type) {
            this[`${type}_options`].forEach(option => {
                option.checked = option.text === text;
            });

            this[`${type}_isShow`] = text === "기타";
        },
        async saveContract() {
            if (this.guest.room_pk === "") {
                return alert("입실 예정인 방 호수를 선택해주세요.");
            }

            if (this.guest.name.trim() === "") {
                this.guest.name = "";
                $("#name").addClass("error");
                return alert("입실자 이름을 입력해주세요.");
            } else {
                $("#name").removeClass("error");
            }

            if (this.guest.birth_date === "") {
                return alert("생년월일을 입력해주세요.");
            }

            if (!this.is_smsCheck.flag) {
                $("#phone_no").addClass("error");
                $("#verify_number").addClass("error");
                return alert("휴대폰 번호 인증을 진행해주세요.")
            } else {
                $("#phone_no").removeClass("error");
                $("#verify_number").removeClass("error");
            }

            if (!this.PHONE_REG_EXP.test(this.e_phone_no)) {
                return alert("올바른 비상 연락처 휴대폰 번호를 입력해주세요.");
            }

            if (this.e_phone_no.trim() === "" || this.relationship.trim() === "") {
                $("#sub").addClass("error");
                return alert("비상 연락처 또는 관계를 모두 입력해주세요.");
            } else {
                $("#sub").removeClass("error");
            }

            if (this.normal_price === "" || this.normal_price < 0) {
                $("#price").addClass("error");
                alert("안내받은 입실료를 입력해주세요.\n또한 0보다 작은 값은 입력할 수 없습니다.");
                return;
            } else {
                $("#price").removeClass("error");
            }

            this.guest.job = this.job_options.find(item => item.checked).text;
            if (this.guest.job === "기타" && this.job_etc.trim() === "") {
                $("#job_etc").addClass("error");
                return alert("직업을 '기타'로 선택한 경우, 내용을 입력해주세요.");
            } else {
                if (this.guest.job === "기타") {
                    this.guest.job = this.job_etc;
                }
                $("#job_etc").removeClass("error");
            }

            this.guest.from_where = this.fromWhere_options.find(item => item.checked).text;
            if (this.guest.from_where === "기타" && this.fromWhere_etc.trim() === "") {
                $("#fromWhere_etc").addClass("error");
                return alert("최초 인지 경로를 '기타'로 선택한 경우, 내용을 입력해주세요.");
            } else {
                if (this.guest.from_where === "기타") {
                    this.guest.from_where = this.fromWhere_etc;
                }
                $("#fromWhere_etc").removeClass("error");
            }

            const cvs = document.getElementById("canvas");
            const isSignature = this.ctx.getImageData(0, 0, cvs.width, cvs.height).data.some(channel => channel !== 0);
            if (!isSignature) {
                return alert("서명란에 서명을 진행해주세요.");
            }

            if (!this.isContentCheck || !this.isPrivacyCheck) {
                return alert("내용 확인 및 개인정보 수집 및 이용에 동의해주세요.");
            }

            try {
                this.isLoading = true;

                // * 이미지 저장 구문
                const file = await this.htmlToBase64();
                const sendData = new FormData();
                sendData.append("filedata", file);
                const result = await this.axios.post("/upload/tempUploadOriginal", sendData);
                this.guest.contract.url = result.data[0];

                // * loading css 를 선으로 진행해도 되지만, 이미지 캡쳐 시  
                this.loading(true);

                // * 메모 가공
                this.guest.memo += `비상 연락처 : ${this.e_phone_no} / 관계 : ${this.relationship}\n`;
                this.guest.memo += `안내받은 입실료 : ${this.normal_price}`;

                // * JSON 가공
                this.guest.deposit = JSON.stringify(this.guest.deposit);
                this.guest.contract = JSON.stringify(this.guest.contract);

                // * 주소 가공
                this.guest.address = `${this.address_1} ${this.address_2}`;

                await this.axios.post("/contract/guest", this.guest);
                alert("정상적으로 처리되었습니다.\n감사합니다.");
                window.location.href = "https://kosirock.com";
            } catch (e) {
                alert("오류가 발생하였습니다. 다시 시도해주세요.");
            } finally {
                this.isLoading = false;
                this.loading(false);
            }
        },
        async htmlToBase64() { // * HTML 태그를 지정하여, base64 이미지 형식으로 저장하는 함수
            const tmp = await html2canvas($("#app")[0]); // * body 상위 객체를 지정하여, html2canvas 객체 생성
            const base64Img = tmp.toDataURL(); // * canvas 객체를 base64 이미지로 변환
            return this.base64ToFile(base64Img, "test.png"); // 파일 객체 생성 후, 리턴
        },
        base64ToFile(base_data, filename) { // * base64 이미지 형식을 파일 형식으로 변환하는 함수 (서버 단에서 저장하려면)
            const arr = base_data.split(",");
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);

            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }

            return new File([u8arr], filename, {
                type: mime
            });
        },
        loading(flag) {
            if (flag) {
                document.querySelector(".loading-wrap").classList.add("on");
                document.querySelector("body").classList.add("loading");
            } else {
                document.querySelector(".loading-wrap").classList.remove("on");
                document.querySelector("body").classList.remove("loading");
            }
        }
    }
}
</script>

<style scoped>
strong {
    font-weight: 700;
}

.img-vertical {
    width: auto;
    display: block;
    margin: 0 auto;
}

.text-center {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 999;
}

#canvas_container {
    width: 100%;
    height: 300px;
    margin: 0 auto;
    padding: 0;
    border: 1px solid #000000;
    /* background-color : #0000ff; */

    /* 컨테이너 배치 정렬 실시 */
    float: top;
    position: relative;
    top: 10%;
    left: 0%;

    /* 마우스 커서 스타일 지정 */
    cursor: pointer;

    /* 브라우저에서 화면 터치 시 파란박스 하이라이트 제거 */
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

    /* div 테두리 영역 둥글게 설정 : 각 모서리 모두 동일 적용 : 일반 설정 */
    border-radius: 20px;
    margin-bottom: 30px;
}
</style>
